import { useSelector } from "react-redux";
import { clear_all_system_alert, remove_system_alert_indicator, system_alert_indicator } from "src/store/slice/system";
import store from "src/storeWire";

export function useDOMAttachToSystemStore() {
    const latest_system_notification_data = useSelector((state) => state.entities.system.DOMAttachToSystem.latest_system_notification_data);
    const latest_system_notification_UUID = useSelector((state) => state.entities.system.DOMAttachToSystem.latest_system_notification_UUID);
    const latest_system_notification_name = useSelector((state) => state.entities.system.DOMAttachToSystem.latest_system_notification_name);
    const system_notification = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification);
    const system_alert_list = useSelector((state) => state.entities.system.system_alert_list);

    let data = {
        latest_system_notification_data,
        latest_system_notification_UUID,
        latest_system_notification_name,
        system_notification,
        system_alert_list
    };
    let fetch = {
        system_alert_indicator: async (params) => {
            return await store.dispatch(system_alert_indicator(params))
        },
        remove_system_alert_indicator: async (params) => {
            return await store.dispatch(remove_system_alert_indicator(params))
        },
        clear_all_system_alert: async () => {
            return await store.dispatch(clear_all_system_alert())
        },
    };
    let set = {};

    return [data, fetch, set]
}